function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  fill: "#F4B940"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.5 6)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("rect", {
  width: "5",
  height: "2",
  rx: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 0h4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z"
}), /*#__PURE__*/React.createElement("rect", {
  y: "3",
  width: "5",
  height: "2",
  rx: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 3h4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z"
}), /*#__PURE__*/React.createElement("rect", {
  y: "6",
  width: "5",
  height: "2",
  rx: ".5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 6h4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z"
})))));